import { Component } from '@angular/core';
import { InvoicePatientCashDeskService } from '../../../services/invoice-cash-desk/invoice-patient-cash-desk.service';
import { InvoiceCashDeskService } from '../../../services/invoice-cash-desk/invoice-cash-desk.service';
import { AdmissionReceptionWizardService, AdmissionWizardService } from '../../../services/wizard/admission/admission.wizzard.service';

@Component({
  selector: 'app-admission-reception-wizard-component',
  templateUrl: './admission-reception-wizard.component.html',
  styleUrls: ['./admission-reception-wizard.component.css'],
  providers: [{ provide: InvoiceCashDeskService, useClass: InvoicePatientCashDeskService }
    , { provide: AdmissionWizardService, useClass: AdmissionReceptionWizardService }]
  })
export class AdmissionReceptionWizardComponent  {

}
